import {
  AcContainer,
  AcFormCard,
  AcTable,
  AcTypography,
} from '@components'
import { LABELS } from '@constants'
import { useStore } from '@hooks/use-store'
import { ITagRelatedProduct } from '@typings'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import styles from './tag-related-items.module.scss'

export interface ITagRelatedProductsTab {
  name?: string
}

export const TagRelatedProductsTab = observer(
  (_props: ITagRelatedProductsTab) => {
    const { tags } = useStore()

    const products = tags.single?.products || []

    return (
      <AcContainer>
        <AcFormCard title={LABELS.RELATED_PRODUCTS}>
          {products.length > 0 ? (
            <AcTable>
              <thead>
                <tr>
                  <th>{LABELS.PRODUCT_NUMBER}</th>
                  <th>{LABELS.NAME}</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product: ITagRelatedProduct) => (
                  <tr key={product.id} className={styles['clickable-row']}>
                    <td>
                      <Link to={`/products/${product.id}`} className={styles['product-link']}>
                        {product.id}
                      </Link>
                    </td>
                    <td>
                      <Link to={`/products/${product.id}`} className={styles['product-link']}>
                        {product.name}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </AcTable>
          ) : (
            <AcTypography>{LABELS.NO_PRODUCTS_LINKED}</AcTypography>
          )}
        </AcFormCard>
      </AcContainer>
    )
  }
)
